<div
  class="overflow-wrapper-y"
  #wrapper
  [attr.data-is-scrolled]="isScrolled"
  [attr.data-is-scrolled-end]="isScrolledEnd"
  [attr.data-overflowing]="isOverflowing"
  [attr.data-snap]="snap"
  [style.scroll-padding-top]="snapPaddingTop"
  [style.max-height]="maxHeight"
>
  <div class="overflow-wrapper-y-inner">
    <ng-content></ng-content>
  </div>
</div>
